import React from "react";

import { OnlineLink } from "components";

import AlertIcon from "static/images/alert.png";
import styles from "./errroPage.module.scss";

export const ErrorPage = ({ title, description, children }) => {
	return (
		<div className={styles.errorBlock}>
			<div className={styles.block}>
				<img src={AlertIcon} alt="" className={styles.alertIcon} />
				<h1 className={styles.title}>{title}</h1>
				<p className={styles.description}>{children || description}</p>
				<OnlineLink className={styles.supportLink} to="#">
					Still have a problem? Contact our support team
				</OnlineLink>
			</div>
		</div>
	);
};
